import { render, staticRenderFns } from "./MyRefundList3.vue?vue&type=template&id=596f027a&scoped=true&"
import script from "./MyRefundList3.vue?vue&type=script&lang=js&"
export * from "./MyRefundList3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596f027a",
  null
  
)

export default component.exports